module.exports = __webpack_public_path__ + "img/question.1d9034f0.svg";